// extracted by mini-css-extract-plugin
export default {"title":"Gaa-z","warning":"Haa-z","sizeOptionsLegendText":"Iaa-z"};